import readMoreHtml from './readMore.html';

class ReadMoreDirective {
    constructor() {
        this.restrict = 'A';
        this.template = readMoreHtml;
        this.transclude = true;
        this.controller = ReadMoreDirectiveController;
        this.controllerAs = '$ctrl';
        this.scope = {};
    }

    link(scope, element, attrs, modelCtrl) {
        scope.display = false;
    }

    static directiveFactory() {
        'ngInject';
        return new ReadMoreDirective();
    }
}

class ReadMoreDirectiveController {
    constructor($scope, $timeout) {
        'ngInject';
        this.$scope = $scope;
    }
}

export default ReadMoreDirective;
